import { render, staticRenderFns } from "./CustomNotification.vue?vue&type=template&id=441ba423&scoped=true&"
import script from "./CustomNotification.vue?vue&type=script&lang=js&"
export * from "./CustomNotification.vue?vue&type=script&lang=js&"
import style0 from "./CustomNotification.vue?vue&type=style&index=0&id=441ba423&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441ba423",
  null
  
)

export default component.exports